module.exports = __webpack_public_path__ + "罗达江-d1a83ca4.png";